import { render, staticRenderFns } from "./GenerateCatalogButton.vue?vue&type=template&id=a0163ff8"
import script from "./GenerateCatalogButton.vue?vue&type=script&lang=ts"
export * from "./GenerateCatalogButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports